<script setup lang="ts">
/**
 * Курсор-рамка: квадрат 26×26, 1px solid accent, следует за мышью.
 * Над button/a/.row/input/textarea вырастает до 40×40 с подложкой
 * color-mix(accent 12%, transparent). Только при (pointer: fine) —
 * на тачскринах компонент просто ничего не делает (курсора там нет).
 * Глушится при prefers-reduced-motion: reduce.
 */
import { onMounted, onUnmounted, ref } from 'vue'

const ring = ref<HTMLDivElement | null>(null)
let attached = false

const HOVER_SELECTOR = 'button, a, .row, input, textarea'

function shouldRun(): boolean {
  if (typeof window === 'undefined') return false
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches
  const finePointer = window.matchMedia('(pointer: fine)').matches
  return !reducedMotion && finePointer
}

function onMove(e: MouseEvent): void {
  const el = ring.value
  if (!el) return
  el.style.opacity = '1'
  el.style.transform = `translate3d(${e.clientX}px, ${e.clientY}px, 0)`
  const target = e.target as HTMLElement | null
  const isInteractive = !!target?.closest?.(HOVER_SELECTOR)
  el.classList.toggle('is-active', isInteractive)
}

onMounted(() => {
  if (!shouldRun()) return
  attached = true
  document.addEventListener('mousemove', onMove, { passive: true })
})

onUnmounted(() => {
  if (attached) document.removeEventListener('mousemove', onMove)
})
</script>

<template>
  <div ref="ring" class="cursor-ring" aria-hidden="true"></div>
</template>

<style scoped>
.cursor-ring {
  position: fixed;
  top: 0;
  left: 0;
  width: 26px;
  height: 26px;
  margin: -13px 0 0 -13px;
  border: 1px solid var(--color-accent);
  background: transparent;
  pointer-events: none;
  z-index: 200;
  opacity: 0;
  transition:
    transform 0.1s linear,
    width 0.22s ease,
    height 0.22s ease,
    margin 0.22s ease,
    background 0.22s ease,
    opacity 0.3s ease;
}

.cursor-ring.is-active {
  width: 40px;
  height: 40px;
  margin: -20px 0 0 -20px;
  background: color-mix(in srgb, var(--color-accent) 12%, transparent);
}
</style>
